import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { SentToEmail } from "./components"

/**
 * Freemium verification email page component.
 * Displays a confirmation message informing the user that the verification email has been sent.
 */

const FreemiumVerificationEmailPage = () => {
  const navigate = useNavigate()
  const auth = useSelector((state) => state.auth)

  useEffect(() => {
    if (auth.isAuthenticated && auth.onboardingStage !== "Trialing") {
      navigate("/")
    }
  }, [auth, navigate])

  return <SentToEmail />
}

export default FreemiumVerificationEmailPage
